// src/PlaneIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var PlaneIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M13.8848 8.51562C14.8453 8.19535 15.407 8.35574 15.666 8.61523C15.9257 8.8754 16.0854 9.43922 15.7676 10.4004L14.2256 15.0225C13.9776 15.768 13.702 16.2885 13.4346 16.6123C13.1658 16.9377 12.9514 17.0137 12.8145 17.0137C12.6775 17.0135 12.4638 16.9373 12.1953 16.6123C11.928 16.2886 11.6523 15.7687 11.4043 15.0234L10.9482 13.6494L10.8691 13.4121L10.6309 13.333L9.25781 12.877C8.51252 12.6288 7.9926 12.353 7.66895 12.0859C7.34367 11.8174 7.26758 11.6034 7.26758 11.4668C7.26758 11.3301 7.34362 11.1158 7.66895 10.8467C7.99252 10.5791 8.51221 10.302 9.25684 10.0527L9.25781 10.0537L13.8848 8.51562Z" })
    ]
  }
);

export {
  PlaneIcon
};
